import { getEnvVar } from '@rea-argonaut/env';

export const getEnv = {
  CANONICAL_DOMAIN: () => getEnvVar<string>('canonicalDomain') || '',
  PUBLIC_EXPERIENCE_API_URL: () => getEnvVar<string>('publicExperienceApiUrl') || '',
  INTERNAL_EXPERIENCE_API_URL: () => getEnvVar<string>('internalExperienceApiUrl') || '',
  GOOGLE_MAP_API_KEY: () => getEnvVar<string>('googleMapApiKey') || '',
};
